import { For, JSX, Show, children, createMemo } from 'solid-js';
import { TOOLBAR_SURFACE_SHADOW_CLASS } from './toolbarSurfaceStyles';

export interface TrbToolbarProps {
  children: JSX.Element | JSX.Element[];
  orientation: 'horizontal' | 'vertical';
  ariaLabel?: string;
  testId?: string;
  customClasses?: string;
  addSeparators?: boolean;
}

export const TrbToolbar = (props: TrbToolbarProps): JSX.Element => {
  const validChildren = createMemo(() => {
    return children(() => props.children)
      .toArray()
      .filter((child) => child != null);
  });

  return (
    <Show when={validChildren().length > 0}>
      <div
        role="toolbar"
        aria-label={props.ariaLabel ?? 'toolbar'}
        data-testid={props.testId}
        class={`${props.orientation === 'vertical' ? 'flex-col' : ''} flex items-center p-[var(--modus-wc-spacing-sm)] rounded-sm bg-base-page ${TOOLBAR_SURFACE_SHADOW_CLASS} ${props.customClasses ?? ''}`}
      >
        <For each={validChildren()}>
          {(child, index) => (
            <>
              {child}
              <Show
                when={
                  (props.addSeparators ?? true) &&
                  index() < validChildren().length - 1
                }
              >
                <modus-wc-divider />
              </Show>
            </>
          )}
        </For>
      </div>
    </Show>
  );
};
